export default __webpack_public_path__ + "static/media/cover-image.694acc34.jpg";